import {ActionIcon, Menu} from "@mantine/core";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faPlus} from "@fortawesome/free-solid-svg-icons";
import {Code} from "tabler-icons-react";
import React from "react";
import {NodeProps, useStore} from "reactflow";
import {SmartTriggerProcessorData} from "../../../../types";
import {useSmartTriggerConfiguration} from "../../../../context/smartTriggerConfigurationProvider";
import {openSpotlight} from "@mantine/spotlight";

export function AddProcessorsMenu(props: NodeProps<SmartTriggerProcessorData>) {

    const data: SmartTriggerProcessorData = props.data;

    const id = props.id;

    let smartTriggerConfiguration = useSmartTriggerConfiguration();
    const previousNodeSize = useStore(s => {
        const node = s.nodeInternals.get(data.previous as string);
        if (!node) {
            return {
                width: 0,
                height: 0
            }
        }
        return {
            width: node.width,
            height: node.height,
        };
    });

    function createNotificationProcessor() {
        smartTriggerConfiguration.addNewProcessor({
            id: "notification-processor",
            data: {
                name: "notification-processor",
                description: 'Notification Processor for connecting the notifiers',
                previous: props.data.previous,
                next: props.id,
            },
            position: {
                x: 0,
                y: 0
            },
            type: 'notification'
        })
        smartTriggerConfiguration.removeProcessor('addNode')
    }


    // function addNewProcessor() {
    //     smartTriggerConfiguration.addNewProcessor({
    //         id: data.previous as string,
    //         width: previousNodeSize.width as number,
    //         height: previousNodeSize.height as number
    //     }, id, 'script');
    // }

    return (
        <Menu size={"xl"} delay={500} placement={"center"}
              control={<ActionIcon color={"gray"} size="xl" radius="xl" variant="outline"><FontAwesomeIcon
                  icon={faPlus} size={"2x"}/></ActionIcon>}>
            <Menu.Label>Processors</Menu.Label>
            <Menu.Item onClick={openSpotlight} icon={<Code size={14}/>}>SCRIPT PROCESSOR</Menu.Item>
            <Menu.Item onClick={createNotificationProcessor} icon={<Code size={14}/>}>NOTIFICATION PROCESSOR</Menu.Item>
            <Menu.Label>Schedulers</Menu.Label>
            <Menu.Item icon={<Code size={14}/>}>CRON SCHEDULER</Menu.Item>
            <Menu.Item icon={<Code size={14}/>}>CONDITIONAL SCHEDULER</Menu.Item>
        </Menu>
    );
}
